/* eslint-disable */
let app_state = {
  //   frontConfig: {
  //     avatars_base_url: "",
  //   },
};
let app_mutations = {
  //   updateUserData: (state, userData) => {
  //     state.userData = userData;
  //   },
};

let app_getters = {
  //   menuItems(state) {
  //     return state.menuItems;
  //   },
};
let app_actions = {};

export { app_state, app_mutations, app_getters, app_actions };
